import { OAuthAuthorize } from "@components/oauth/authorization/OAuthAuthorize";
import { OAuthCallback } from "@components/oauth/authorization/OAuthCallback";
import { Route } from "react-router-dom";

export const useRenderOAuthRoutes = () => (
    <Route path="/oauth">
        <Route path="authorize/:service" element={<OAuthAuthorize />} />
        <Route path="callback/:service" element={<OAuthCallback />} />
    </Route>
);
